import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";

import { toastError, toastSuccess } from "../../utils/react-toaster";
import {
  deleteMenuData,
  getAllMenusData,
  saveAllMenusData,
  saveMenuData,
} from "../slices";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  success?: boolean;
  code?: any;
  results?: any;
  productvo?: any;
}

function* fetchAllMenusData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.MENUS.getAllMenusApi,
    });
    if (response) {
      yield put(saveAllMenusData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteMenu(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.MENUS.deleteMenuApi(actions.payload.mid),
    });
    if (response.code) {
      toastError(response.code);
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* saveMenu(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.MENUS.saveMenuApi,
      data: actions.payload.dataToPost,
    });
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(saveMenuData.type, saveMenu);
  yield takeEvery(getAllMenusData.type, fetchAllMenusData);
  yield takeEvery(deleteMenuData.type, deleteMenu);
}
